export default __webpack_public_path__ + "static/media/lp_menu_icon.f4b2a552.svg";